import {
  ActionType,
  IFactorsNEffectsPayload,
  IFactorsNEffectsResponse,
} from "models/stressCheck/factorsNEffects";

export const getFactorsNEffectsAction = (payload: IFactorsNEffectsPayload) => {
  return {
    type: ActionType.FACTOR_N_EFFECTS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FACTOR_N_EFFECTS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IFactorsNEffectsResponse) => {
  return {
    type: ActionType.FACTOR_N_EFFECTS_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.FACTOR_N_EFFECTS_RESET,
  };
};
